import { useDispatch } from "react-redux";
import { nextStep, prevStep, resetStep, setStep } from "..";

export const useStepActions = () => {
  const dispatch = useDispatch();

  return {
    next: () => dispatch(nextStep()),
    prev: () => dispatch(prevStep()),
    set: (step: number) => dispatch(setStep(step)),
    reset: () => dispatch(resetStep()),
  };
};
